var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAireOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5829 5.96829L2.92754 0.75C0.0309516 8.16546 3.75514 16.5422 11.3414 19.426L24.8589 24.6443C27.7554 17.2288 24.0313 8.85208 16.5829 5.96829Z",
    fill: "#FF972F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6869 28.4893L36.1695 23.271C33.2729 30.6865 36.9971 39.2005 44.4454 41.947L57.9628 47.1653C60.8594 39.7498 57.1352 31.3731 49.6869 28.4893Z",
    fill: "#FF972F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4105 40.5742L15.8931 35.356C12.9965 42.7714 16.7207 51.1481 24.307 54.0319L37.8244 59.2502C40.721 51.8348 36.9968 43.3207 29.4105 40.5742Z",
    fill: "#FF972F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAireOrange);
export default __webpack_public_path__ + "static/media/aire-orange.d7f1807c641a931f5a183ff2e18766cf.svg";
export { ForwardRef as ReactComponent };